import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Columns, FlexBox, IconButton, Text, } from '@dixa/lib-shared-habla';
import { sizes } from '@dixa/lib-shared-tokens';
import { useCallback, useState } from 'react';
import { ConversationSidebarButton } from './components/button/conversationSidebarButton';
import styles from './conversationSidebar.module.scss';
import { conversationSidebarConfig, conversationSidebarItems, } from './utils/conversationSidebarItems';
/** Represents the sidebar area of the conversation view. */
export const ConversationSidebar = () => {
    // NOTE: Probably should store these state values in local storage so that
    // they are persistent across sessions per conversation id.
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
    const [activeSidebarId, setActiveSidebarId] = useState();
    /** Handles closing the sidebar. */
    const closeSidebar = useCallback(() => {
        setIsSidebarCollapsed(true);
        setActiveSidebarId(undefined);
    }, []);
    /**
     * Handles toggling the sidebar.
     *
     * @param sidebarId The sidebar item id.
     */
    const toggleSidebar = useCallback((sidebarId) => {
        if (sidebarId === activeSidebarId) {
            closeSidebar();
        }
        else {
            setIsSidebarCollapsed(false);
            setActiveSidebarId(sidebarId);
        }
    }, [activeSidebarId, closeSidebar]);
    return (_jsxs(Columns, { children: [!isSidebarCollapsed && (_jsxs(Column, Object.assign({ size: "340px" }, { children: [_jsxs(Column.Row, Object.assign({ slottable: true, noMinHeight: true, style: { paddingRight: sizes.spacer[250] } }, { children: [_jsx(Column.Slot, Object.assign({ placement: "start" }, { children: _jsx(Text.Heading, Object.assign({ variant: "heading-2" }, { children: activeSidebarId &&
                                        conversationSidebarConfig[activeSidebarId].name })) })), _jsx(Column.Slot, Object.assign({ placement: "end", noVerticalPadding: true }, { children: _jsx(IconButton, { icon: "close", size: "normal", variant: "tertiary", onClick: closeSidebar }) }))] })), _jsx(Column.Row, Object.assign({ scrollable: true }, { children: "sidebar content" }))] }))), _jsx(Column, Object.assign({ className: styles.buttonsColumn, size: "auto" }, { children: _jsx(Column.Row, Object.assign({ scrollable: true, noMinHeight: true, noHorizontalPadding: true, noVerticalPadding: true }, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column" }, { children: conversationSidebarItems.map((sidebarId) => (_jsx(ConversationSidebarButton, { sidebarId: sidebarId, isActive: activeSidebarId === sidebarId, onClick: () => toggleSidebar(sidebarId) }, sidebarId))) })) })) }))] }));
};
